/* tslint:disable */
/* eslint-disable */
/**
 * Airline API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * The time at which the modification is requested
 * @export
 */
export const ModificationTime = {
    AfterDeparture: 'after_departure',
    Anytime: 'anytime',
    BeforeDeparture: 'before_departure'
};
export function ModificationTimeFromJSON(json) {
    return ModificationTimeFromJSONTyped(json, false);
}
export function ModificationTimeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ModificationTimeToJSON(value) {
    return value;
}
